import {skipToken} from '@reduxjs/toolkit/query';
import {DataStatus} from 'platform/components';
import {Box} from 'platform/foundation';

import {isNil, isNotNil} from 'ramda';

import {useSourcingVehicleDetailQuery} from '@dms/api/core';

import {suffixTestId, TestIdProps} from 'shared/web';

import {AdvanceVehicleView} from '../../../../../../../components/AdvanceVehicleView/AdvanceVehicleView';
import {SourcingListSkeleton} from '../../../../../../../components/SourcingListSkeleton/SourcingListSkeleton';
import {useSourcingCurrency} from '../../../../../../../hooks/useSourcingCurrency';
import {useSourcingPricingStrategy} from '../../../../../../../hooks/useSourcingPricingStrategy';
import {useSourcingTargetCountry} from '../../../../../../../hooks/useSourcingTargetCountry';
import {isUnifiedSourcingEnabled} from '../../../../../../../utils/isUnifiedSourcingEnabled';

interface SourcingVehicleCardProps extends TestIdProps {
  externalId: string;
  isFullHeight?: boolean;
}

export const SourcingVehicleCard = (props: SourcingVehicleCardProps) => {
  const currency = useSourcingCurrency()?.code;
  const country = useSourcingTargetCountry()?.code;
  const pricingStrategy = useSourcingPricingStrategy();
  const {data, currentData, isFetching, isError} = useSourcingVehicleDetailQuery(
    isNotNil(props.externalId)
      ? {externalId: props.externalId, currency, buyerCountry: country, pricingStrategy}
      : skipToken
  );
  const enhancedSurfaces = isUnifiedSourcingEnabled();
  const vehicle = enhancedSurfaces ? currentData : data;

  return (
    <Box
      minHeight={props.isFullHeight ? '100%' : undefined}
      borderRadius="medium"
      boxShadow="elevation_1"
      backgroundColor="palettes.white.10.100"
      data-testid={suffixTestId('selectedVehicle-advancedVehicleView', props)}
    >
      <DataStatus
        isLoading={!enhancedSurfaces && isFetching}
        isError={isError}
        minHeight={50}
        data-testid={props['data-testid']}
      >
        {enhancedSurfaces && isFetching && isNil(vehicle) ? (
          <SourcingListSkeleton rowCount={1} />
        ) : (
          <AdvanceVehicleView
            isHoverDisabled={enhancedSurfaces}
            vehicle={vehicle}
            data-testid={suffixTestId(
              `selectedVehicle-advancedVehicleView[${props.externalId}]`,
              props
            )}
          />
        )}
      </DataStatus>
    </Box>
  );
};
